import * as React from 'react';
export const IcVoiceRecording = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.28 9.19c.4-.11.7-.47.72-.9.03-.6.35-1.16.83-1.51.45-.32.55-.95.23-1.39a.985.985 0 00-1.39-.23c-.99.71-1.6 1.81-1.67 3.02-.03.55.39 1.02.94 1.06.12 0 .23 0 .34-.04v-.01zM14 20h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zM6.83 3.9c.5-.24.71-.84.47-1.33a.996.996 0 00-1.33-.47 6.972 6.972 0 00-3.92 7.1c.06.55.56.94 1.11.88.06 0 .11-.02.16-.03.46-.13.77-.58.71-1.08-.24-2.11.88-4.15 2.8-5.07zM12 15a2.5 2.5 0 002.5-2.5v-6a2.5 2.5 0 00-5 0v6A2.5 2.5 0 0012 15zm5.5-3.5c-.55 0-1 .45-1 1 0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5c0-.55-.45-1-1-1s-1 .45-1 1c0 3.58 2.92 6.5 6.5 6.5s6.5-2.92 6.5-6.5c0-.55-.45-1-1-1zm.53-9.4a.99.99 0 00-1.33.47.99.99 0 00.47 1.33c1.92.92 3.04 2.96 2.8 5.07-.06.49.25.94.71 1.08.05.02.11.03.16.03.55.06 1.04-.33 1.11-.88a7 7 0 00-3.92-7.11v.01zm-.71 3.05a.994.994 0 00-1.39.23.994.994 0 00.23 1.39c.49.35.8.91.83 1.51.03.44.32.79.72.9.11.03.22.04.34.04.55-.03.97-.5.94-1.06a3.988 3.988 0 00-1.67-3.02v.01z'
      fill='currentColor'
    />
  </svg>
);
